import { render, staticRenderFns } from "./IconGridView.vue?vue&type=template&id=6fde7969&"
import script from "./IconGridView.vue?vue&type=script&lang=ts&"
export * from "./IconGridView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports